export interface Term {
    displayName: string;
    term: string;
    hits: number;
    fieldName: string;
    id: number;
    selected: boolean;
    alwaysShow: boolean;
    from: any; // Consider the appropriate type
    to: any; // Consider the appropriate type
    description: string | null;
}

export interface Facet {
    displayName: string;
    description: string | null;
    terms: Term[];
    facetDisplayOption: number;
    fieldName: string;
    showMoreAmount: number;
    searchFields?: string[];
}

/* Cel Result */

export interface Result {
    title: string;
    description: string;
    url: string | null;
    externalContentUrl: string | null;
    hitId: string;
    categories: string[] | null;
    isBestBet: boolean;
    isPublic: boolean;
    rolesWithReadAccess: string[] | null;
    id: number;
    schoolName: string | null;
    schoolShortName: string | null;
    code: string | null;
    startDate: string | null;
    startTime: string | null;
    endDate: string | null;
    endTime: string | null;
    durationDays: number | null;
    gradesServed: string[] | null;
    programCategories: string[] | null;
    primaryContact: string | null;
    isLocal: boolean;
    searchResultType: number;
    address: string;
    phoneNumber: string;
    gradesOffered: string[] | null;
    mapLinkUrl: string | null;
    isGoCPSParticipant: boolean;
    studentCount: number;
    network: string | null;
    community: string | null;
    adaAccessibility: boolean | null;
    hasDressCode: boolean;
    programTypes: string[] | null;
    programs: string[] | null;
    summerPrograms: string[] | null;
    governance: string | null;
    rating: string | null;
    campusAccessibility: string | null;
    parkingAccessibility: string | null;
    schoolType: string;
    availability: string;
    fullYear: string | null;
    schoolYear: string;
    fullDayProgram: string;
    partDayProgram: string | null;
    agesServed: string;
    ageRangesServed: string;
    qualityRating: string;
    websiteURL: string | null;
    facebookURL: string | null;
    twitterURL: string | null;
    youtubeURL: string | null;
    facets: ResultFasets;
}
export interface ResultFasets {
    id?: string[] | null;
    availability: string[];
    isSchoolYearFacet: string[];
    postalCode: string[];
    enrollmentYear: string[];
    qualityRating: string[];
    acceptsCCAPFacet: string[];
    schoolType: string[];
    ageGroupsFullName: (string | null)[];
    fullDayProgramFacet: string[];
    community: string[];
}
export interface CelRequest {
    context: string;
    didYouMean: string | null;
    facets: Facet[];
    results: Result[]; 
    schools: any[] | null; // You might want to define a type for schools if they have a specific structure
    searchTerm: string | null;
    showUrl: boolean;
    totalResults: number;
    trackingId: string;
}

export interface PrekSchool {
    type: SchoolType,
    _epi: Result;
}
export type SchoolType = 'cel' | 'cps' | 'prog';
export const SCHOOL_TYPE = {
    CEL: 'cel',
    CPS: 'cps',
    SUMMER_PROGRAMM: 'prog'
}

export type Mode = 'prog' | 'gocps' | 'cps' | 'prek';

export const PAGE_MODE = {
    SUMMER_PROGRAMM: 'prog', 
    GOCPS: 'gocps',
    CPS: 'cps',
    PREK: 'prek'
}